//
//
//
//
//
//
//
//
//
//
//
//
//

import AxiosErrorHandler from '@/mixins/AxiosErrorHandler'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'ClientRate',
  mixins: [AxiosErrorHandler],
  props: {
    clientId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      rate: 0,
      count: 0
    }
  },
  async mounted () {
    try {
      const { data } = await this.$axios.get(`/clients/${this.clientId}/rate`)
      if (data?.data) {
        const {
          rate,
          count
        } = data.data
        this.rate = rate
        this.count = count
      }
    } catch (err) {
      await this.handleError(err)
    }
  }
}
